// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"38562fff","972":"0b2d0fe4"}[chunkId] + ".chunk.css";
};